import Box from "@material-ui/core/Box";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import { visuallyHidden } from "@material-ui/utils";
import * as React from "react";

const headCells = [
  {
    id: "ID",
    numeric: false,
    disablePadding: false,
    label: "Order ID",
  },
  {
    id: "CustomerName",
    numeric: false,
    disablePadding: false,
    label: "Customer",
  },
  {
    id: "DatePlaced",
    numeric: false,
    disablePadding: false,
    label: "Date Placed",
  },
  {
    id: "PickupTime",
    numeric: false,
    disablePadding: false,
    label: "Pickup Time",
  },
  {
    id: "Fulfilled",
    numeric: false,
    disablePadding: false,
    label: "Fulfilled",
  },
  {
    id: "Comment",
    numeric: false,
    disablePadding: false,
    label: "Comment",
  },
];

function LatestOrdersHeader(props) {
  const {
    onSelectAllClick,
    order,
    orderBy,
    numSelected,
    rowCount,
    onRequestSort,
  } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={"center"}
            padding={headCell.disablePadding ? "none" : "default"}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={headCell.id === "view" ? false : orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={
                headCell.id === "view" ? null : createSortHandler(headCell.id)
              }
              hideSortIcon={headCell.id === "view"}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <Box component="span" sx={visuallyHidden}>
                  {order === "desc" ? "sorted descending" : "sorted ascending"}
                </Box>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

export default LatestOrdersHeader;
